import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useListAllFeatureFlagsQuery } from '@/admin/featureFlags/api/featureFlagsApi';
import { getClientConfigBrokerGroupIds, needsInsightIds } from '../../userValidationSchema';
import { InsightIdField } from './InsightIdField';

/**
 * The user drawers' Ledger information section: the user's Insight ids, each a dropdown of
 * that Insight list for their primary broker group's ledger (InsightIdField). For a new user
 * (isNew) who needsInsightIds (their primary broker group doesn't take them from client
 * config, clientConfigInsightSelection, and they're not a Folio admin), sales team and
 * authorised rep are required, unless the field's Insight list has nothing to pick.
 */
export const LedgerFields = ({ isNew = false }) => {
	const { values } = useFormikContext();
	const { data: flags = [] } = useListAllFeatureFlagsQuery();
	const needsIds = isNew && needsInsightIds(values, getClientConfigBrokerGroupIds(flags));

	return (
		<>
			<Grid size={12}>
				<Typography variant='form_label'>Ledger information</Typography>
			</Grid>
			<InsightIdField name='salesTeamId' needsInsightIds={needsIds} />
			<InsightIdField name='serviceTeamId' />
			<InsightIdField name='accountTypeId' />
			<InsightIdField name='authorisedRepId' needsInsightIds={needsIds} />
		</>
	);
};

LedgerFields.displayName = 'LedgerFields';
